import styled from "styled-components";

const MenuWrapper = styled.div`
  width: 20rem;
  margin-bottom: 1rem;
`;

export { MenuWrapper };
